<div class="page-layout inner-scroll" id="lessons">
  <!--only for accessibility for read answer result-->
  <div style="width:0;height:0;color:transparent" role="status" aria-live="assertive" class="status-message">
    {{ statusAnswerMessage }}
  </div>
  <app-stepper-wrapper [lessonMode]="!!activitiesService.currentAssignment" [stepperOptions]="stepperOptions"
    class="inner-scroll" [ngClass]="{'progress-multi-zone-is-display':showMultiZoneProgressBar()}">
    <!-- boutons exportables vers les différents stepper ou barre de progression -->
    <ng-template #toolsMenuTemplate>
      @if (allowedToolsPlugins.length > 0) {
        <button
          id="button-tools"
          (click)="$event.stopPropagation();"
          [matMenuTriggerFor]="toolsMenu"
          class="fuse-app-lessons__button-tools"
          [matTooltip]="'activities.lesson.tools' | translate"
          [disabled]="headerButtonAreLocked$ | async">
          <mat-icon svgIcon="tools-circle"></mat-icon>
        </button>
      }
      <mat-menu #toolsMenu="matMenu">
        @for (tool of allowedToolsPlugins; track tool) {
          <button (click)="executeTool(tool)"
            mat-menu-item>
            <span>{{ tool.setting.label | translate }}</span>
          </button>
        }
      </mat-menu>
    </ng-template>
    <ng-template #buttonFullscreenTemplate>
      @if (displayFullscreenButton) {
        <button
          (click)="toggleFullscreen()"
          [disabled]="headerButtonAreLocked$ | async"
          class="fuse-app-lessons__button-fullscreen"
          [matTooltip]="(fullscreenService.isFullScreenActive ? 'activities.lesson.exit_full_screen' : 'activities.lesson.enter_full_screen') | translate">
          <mat-icon
          [svgIcon]="'fullscreen' + (fullscreenService.isFullScreenActive ? '_exit' : '')"></mat-icon>
        </button>
      }
    </ng-template>
    <ng-template #buttonCloseTemplate>
      <button
        (click)="goBack()" [ngClass]="displayCloseButtonPng?'close_header':''"
        class="fuse-app-lessons__button-close"
        id="app-lessons_button-close"
        [matTooltip]="'activities.lesson.exit' | translate"
        [disabled]="headerButtonAreLocked$ | async">
        <mat-icon svgIcon="cross"></mat-icon>
      </button>
    </ng-template>

    <div toolbar-before-stepper>
      <div *ngTemplateOutlet="toolsMenuTemplate"></div>
    </div>
    <div toolbar-after-stepper>
      <div *ngTemplateOutlet="buttonFullscreenTemplate"></div>
      <div *ngTemplateOutlet="buttonCloseTemplate"></div>
    </div>

    <div [ngClass]="{'js-latex-is-open' : isLatexKeyboardDisplayed}" class="center stepper-wrapper__container" fxFlex fxLayout="column">
      @if (!isLoading) {
        @if ((showHeaderExo || hasLessonSteps) && !displayStepper) {
          <div class="header fuse-app-lessons-header stepper-wrapper__header"
            [ngClass]="{'no-title' : !this.showActivityTitle}">
            @if (showHeaderExo && totalOfExercises()>0) {
              <div
                class="header-top">
                @if (displayHelpButton) {
                  <button role="button"
                    class="help fuse-app-lessons__button-help"
                    [ngStyle]="{ visibility:getFeedBack() === ''?'hidden':'visible'}"
                    (click)="help()" >
                    <mat-icon svgIcon="help"></mat-icon>
                    <span class="sr-only">{{'accessibility.header.exo.help' | translate}}</span>
                  </button>
                }
                @if (showLessonTitle) {
                  <span class="title bem-fuse-app-lessons__title" data-tralalere-identifier="showLessonTitle">
                    @if (lessonTitleIcon) {
                      <mat-icon svgIcon="titleIconLesson"></mat-icon>
                    }
                  {{lessonTitle}}</span>
                }
                @if (showActivityTitle) {
                  <span
                    class="title"
                  data-tralalere-identifier="showActivityTitle"> {{getStepTitlePrefixPosition() ? currentStep + '-' : ''}} {{activityTitle}}</span>
                }
                @if (showActivityQuestionIndex) {
                  <span
                    class="title"
                    data-tralalere-identifier="showActivityQuestionIndex"> {{'generic.question' | translate}} {{this.activitiesService.currentActivityIndex }}
                  /{{totalOfExercises()}}</span>
                }
                <div class="toolbar" fxLayoutAlign="start center">
                  @if (learnerInfo) {
                    <span class="ml-12 mr-24 learner-info">
                      {{ 'generic.learner' | translate }} : {{learnerInfo.name}}
                      - {{ 'generic.label_group' | translate }} : {{learnerInfo.classes}}
                    </span>
                  }
                  <div *ngTemplateOutlet="toolsMenuTemplate"></div>
                  <div *ngTemplateOutlet="buttonFullscreenTemplate"></div>
                  <div *ngTemplateOutlet="buttonCloseTemplate"></div>
                </div>
              </div>
            }
            @if (hasLessonSteps) {
              <div class="header-bottom">
                <h2>{{ stepTitle | translate }}</h2>
              </div>
            }
          </div>
        }
        <!--hide content until all data are ready to avoid unsynchronize screen opening-->
        <content class="stepper-wrapper__content">
          @if (showMultiZoneProgressBar()) {
            <app-progress-multi-zone
              [answers]="answersCopy"
              [numberOfQuestion]="numberOfQuestion || totalOfExercises()"
              aria-hidden="true">
            </app-progress-multi-zone>
          }
          @if (displayFeedbacks) {
            <app-feedback></app-feedback>
          }
          <div class="outlet-player-navigation">
            <div class="previous-wrapper">
              @if (isArrowNavigationEnabled('previous')) {
                <button [disabled]="isLoading" (click)="previousActivity()"
                  aria-label="preview"
                  class="previous" >
                  <mat-icon svgIcon="arrow_left_circle_outline"></mat-icon>
                </button>
              }
            </div>
            <router-outlet></router-outlet>
            <div class="next-wrapper">
              @if (isArrowNavigationEnabled('next')) {
                <button [disabled]="isLoading" (click)="nextActivity()"
                  aria-label="next"
                  class="next" >
                  <mat-icon svgIcon="arrow_right_circle_outline"></mat-icon>
                </button>
              }
            </div>
          </div>
          @if (showGenericProgressBar()) {
            <app-progress-bar-generic
              [numberOfSteps]="0"
              [pourcent]="progression"
            ></app-progress-bar-generic>
          }
        </content>

        <!-- This is to manage the user actions. This is not fixed. We need to findout a good way to
        manage show and hide of these buttons. -->
        <div class="footer fuse-app-lessons-content-footer" fxFlex="none">
          <!--                   <app-user-action-button
          [activityId]='getCurrentActivityOrMediaId()'
          [activityTitle]="activityTitle"
          [isMedia]="isMedia()"
          [showButtons]="isUserActionButtonsAllowed"
        ></app-user-action-button>-->
      </div>
    }
    @if (isLoading) {
      <div class="spinner-wrapper">
        <mat-spinner></mat-spinner>
      </div>
    }
  </div>
</app-stepper-wrapper>
</div>